import axios from 'axios';
import { CardAndFields, CardInfo, EditCardRequest, LoginRequest, User } from './types';

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const setLogin = function (phone: string, code: string) {
    const request: LoginRequest = {
        phone,
    };

    if (code) {
        request.code = code;
    }

    return axios.post('/api/user/login', request);
};

export const getUser = function (): Promise<User> {
    return axios.get('/api/user/login').then((result) => result.data);
};
export const getCards = function (): Promise<Array<CardInfo>> {
    return axios.get('/api/user/card').then((result) => result.data);
};

export const getCard = function (id: string): Promise<CardAndFields> {
    return axios.get('/api/user/card/' + id).then((result) => result.data);
};

export const editCard = function (id: string, body: EditCardRequest): Promise<CardAndFields> {
    return axios.patch('/api/user/card/' + id, body).then((result) => result.data);
};
